import {
    imageGenerationTimeBudget,
    getSimilarImageServerlessUrl,
    getMatchingImageServerlessUrl,
    getFittingImageServerlessUrl,
    getImageWithNoBackgroundServerlessUrl,
    getEditedImageServerlessUrl,
    getUpscaledImageServerlessUrl
} from '../constants'
import type {ImageUrls} from '@wix/document-services-types'

export interface CommonImageFetchParams {
    userImage: string
    height_RunwareFlux: string
    width_RunwareFlux: string
}
export interface MatchImageToPageParams extends CommonImageFetchParams {
    Site_Description: string
}
export interface RemoveImageBackgroundParams {
    imageUrl: string
}
export interface EditImageParams extends CommonImageFetchParams {
    editRequest: string
}
export interface UpscaleImageParams {
    imageUrl: string
}

export const postForImageUrls = async (
    serverFacade: any,
    msid: string,
    endpoint: string,
    paramsMap: Record<string, any>
): Promise<ImageUrls> => {
    const {message} = await serverFacade.post(endpoint, paramsMap, {
        'x-wix-meta-site-id': msid,
        'X-Time-Budget': imageGenerationTimeBudget
    })
    return JSON.parse(message)
}

export const fetchSimilarImageUrls = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, CommonImageFetchParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getSimilarImageServerlessUrl, paramsMap)

export const fetchMatchingImages = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, MatchImageToPageParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getMatchingImageServerlessUrl, paramsMap)

export const fetchFittingImages = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, CommonImageFetchParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getFittingImageServerlessUrl, paramsMap)

export const fetchImagesWithNoBackground = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, RemoveImageBackgroundParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getImageWithNoBackgroundServerlessUrl, paramsMap)

export const fetchEditedImages = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, EditImageParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getEditedImageServerlessUrl, paramsMap)

export const fetchUpscaledImages = async (
    serverFacade: any,
    msid: string,
    paramsMap: Record<string, UpscaleImageParams>
): Promise<ImageUrls> => postForImageUrls(serverFacade, msid, getUpscaledImageServerlessUrl, paramsMap)

export type Fetcher<TParams> = (serverFacade: any, msid: string, params: TParams) => Promise<string>
